/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Preferences_DescriptionInputs */



/**
* | output |
* | --- |
* | "How answers should look, like language, tone or format." |
*
* @param {Memory_Preferences_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_preferences_description = /** @type {((inputs?: Memory_Preferences_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Preferences_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie Antworten aussehen sollen, z. B. Sprache, Ton oder Format.")
	return /** @type {LocalizedString} */ ("How answers should look, like language, tone or format.")
});